import { usePersonaStore } from "@/store/usePersonaStore";
import { displayAssistantName } from "@/lib/personaSamples";

/** Human-readable assistant name — persona store is the source of truth. */
export function useAssistantName() {
  return displayAssistantName(usePersonaStore((s) => s.name));
}
